import styled from 'styled-components';

interface IProps {
    clipRight: number;
}

export const Overlay = styled.div.attrs((props: IProps) => ({
    style: {
        clip: `rect(0px ${props.clipRight}px 300px 0px)`,
    },
}))<IProps>`
    position: absolute;
    overflow: hidden;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
`;
